import {Component, EventEmitter, Input, Output, signal} from '@angular/core';

@Component({
  selector: 'pt-button-with-loader',
  template: `
    <button type='button' *ngIf="!showConfirm()" [disabled]='disabled'
            [class]="cssClass ?? 'btn btn-sm btn-primary gap-1'" (click)="onClickBtn()">
      <div [ngSwitch]='loading'
           [class.icon-loader-container]="loading"
           [class.prevent-loading-resize]="mainIcon">
        <ng-container *ngSwitchCase='false'>
          <pt-icon *ngIf='mainIcon' [key]='mainIcon'></pt-icon>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <pt-icon *ngIf='mainIcon' [key]='mainIcon'></pt-icon>
        </ng-container>

        <div *ngSwitchCase='true' class='pt-icon-emulation'>
          <div class='spinner-border spinner-border-sm'></div>
        </div>
      </div>
      <div>{{ label }}</div>
    </button>
    <ng-container *ngIf="showConfirm()">
      <div class="d-flex gap-2">
        <span>{{confirmMessage | translate}}</span>
        <div class="d-flex gap-1">
          <button class="btn btn-sm btn-primary" data-testid="btn-confirm"  (click)="onClickConfirm()">{{ 'BUTTON.CONFIRM' | translate }}</button>
          <button class="btn btn-sm btn-secondary" data-testid="btn-cancel"  (click)="onClickCancel()">{{ 'BUTTON.CANCEL' | translate }}</button>
        </div>
      </div>
    </ng-container>
  `,
  styles: [`
    button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .prevent-loading-resize {
      display: flex;
      min-width: 18px;
      min-height: 18px;
      align-items: center;
    }

    .icon-loader-container {
      width: 22px;
      min-width: 22px;
      height: 100%;
    }
    .pt-icon-emulation {
      height: 10px;
      width: 25px;
      margin-top: -7px;
      margin-right: -5px;
      min-width: 25px;
      margin-bottom: -6px;
      min-height: 18px;
      display: flex;
      align-items: center;
      vertical-align: middle;
      pointer-events: none;
    }
  `]
})
export class ButtonWithLoaderComponent {
  @Input() label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() mainIcon: any;
  @Input() cssClass: string;
  @Input() loading: boolean;
  @Input() disabled: boolean;
  @Input() withConfirm: boolean;
  @Input() confirmMessage: string;

  @Output() buttonWithLoaderClick = new EventEmitter<void>();

  public showConfirm = signal(false);

  onClickBtn() {
    if (this.withConfirm) {
      this.showConfirm.set(true);
    } else {
      this.buttonWithLoaderClick.emit();
    }
  }

  onClickConfirm() {
    this.showConfirm.set(false);
    this.buttonWithLoaderClick.emit();
  }

  onClickCancel() {
    this.showConfirm.set(false);
  }
}
